<template>
  <custom-dialog
    :visible="visible"
    width="600px"
    class="invoice-apply-dialog"
    :title="model.title"
    v-on="$listeners"
    :append-to-body="true"
  >
    <div class="dialog-body">
      <div class="input-container">
        <el-form
          :model="form"
          :rules="rules"
          ref="form"
        >
          <el-form-item :label="$t('fms_receive_invoice_apply_dialog.fa_piao_jin_e')">
            <el-input
              type="text"
              v-model="invoiceAmount"
              placeholder=""
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('fms_receive_invoice_apply_dialog.fa_piao_lei_xing')"
            prop="invoiceTypeValue"
          >
            <invoice-type-select
              v-model="form.invoiceTypeValue"
              ref="invoiceTypeSelect"
              @change="updateTypeAndClassByValue(form, $event)"
              @init="initTypeAndClassByValue(form, $event)"
            ></invoice-type-select>
          </el-form-item>
          <el-form-item
            :label="$t('fms_receive_invoice_apply_dialog.fa_piao_tai_tou')"
            prop="partnerInvoiceId"
            class="last-row"
          >
            <custom-select
              v-model="form.partnerInvoiceId"
              :fullUrl="fullUrl"
              :props="{ label: 'buyerName', value: 'partnerInvoiceId' }"
              width="100%"
              @change="onTitleChange"
              ref="partnerInvoiceId"
            ></custom-select>
            <div
              class="add-invoice"
              @click="addBodyItem"
            >
              <i class="icon icon-add"></i>
              <span class="label">{{ $t('fms_receive_invoice_apply_dialog.fa_piao_tai_tou') }}</span>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <div
        class="msg-content"
        v-if="form.partnerInvoiceId"
      >
        <div class="title">{{ $t('fms_receive_invoice_apply_dialog.fpttxx') }}</div>
        <ul class="msg-list">
          <li>
            <div class="key">{{ $t('fms_receive_invoice_apply_dialog.shui_hao') }}：</div>
            <div class="val">{{ form.buyerNumber }}</div>
          </li>
          <li>
            <div class="key">{{ $t('fms_receive_invoice_apply_dialog.ming_cheng') }}：</div>
            <div class="val">{{ form.buyerName }}</div>
          </li>
          <li>
            <div class="key">{{ $t('fms_receive_invoice_apply_dialog.dan_wei_di_zhi') }}：</div>
            <div class="val">{{form.buyerRegisterAddress}}</div>
          </li>
          <li>
            <div class="key">{{ $t('fms_receive_invoice_apply_dialog.dian_hua_hao_ma') }}：</div>
            <div class="val"> {{ form.buyerMobile }}</div>
          </li>
          <li>
            <div class="key">{{ $t('fms_receive_invoice_apply_dialog.kai_hu_yin_hang') }}：</div>
            <div class="val">{{ form.buyerDepositBank }}</div>
          </li>
          <li>
            <div class="key">{{ $t('fms_receive_invoice_apply_dialog.yin_hang_zhang_hao') }}：</div>
            <div class="val">{{form.buyerDepositNumber}}</div>
          </li>
          <li>
            <div class="key">{{ $t('fms_receive_invoice_apply_dialog.you_xiang') }}：</div>
            <div class="val">{{form.buyerEmail}}</div>
          </li>
        </ul>
      </div>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="visible = false">{{ $t('Common.com_close') }}</el-button>
      <el-button @click="onSave">{{ $t('fms_receive_invoice_apply_dialog.jrdkplb') }}</el-button>
      <el-button
        @click="onSubmit"
        type="primary"
      >{{ $t('fms_receive_invoice_apply_dialog.tjkpsp') }}</el-button>
    </div>
    <body-item-dialog
      v-if="bodyItemVisible"
      @close="bodyItemVisible=false"
      :model="bodyItemModel"
      @success="onSuccess"
      :showEmail="true"
      :partnerOrgId="firstItem.payableOrgId"
    ></body-item-dialog>
    <!-- 财务申请审批 -->
    <approval-dialog
      v-if="dialogVisible1"
      :model="dialogModel1"
      @close="onSubmitClose"
      @success="onSubmitSuccess"
    ></approval-dialog>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';
import approvalDialog from '@/components/approvalCenter/approval_dialog.vue';
import invoiceTypeSelect from '@/components/invoiceTypeSelect.vue';
import invoiceTypeMixins from '@/mixins/invoice_type_mixins.js';
import bodyItemDialog from './body_item_dialog';

export default {
  mixins: [dialogMixins, invoiceTypeMixins],
  components: { bodyItemDialog, approvalDialog, invoiceTypeSelect },
  data() {
    return {
      firstItem: {},
      fullUrl: '',
      form: {
        invoiceAmount: '',
        invoiceTypeValue: '',
        invoiceType: '',
        invoiceClass: '',
        partnerInvoiceId: '',
        buyerNumber: '',
        buyerName: '',
        buyerEmail: '',
      },

      bodyItemVisible: false,
      bodyItemModel: {},
      // 待开票列表
      waitList: [],
      dialogModel1: {},
      dialogVisible1: false,
      // 开票类型数据
      invoiceTypeData: [],
      invoiceTypeValue: '',
      // 是否正在submiting
      submiting: false,
    };
  },
  computed: {
    rules() {
      return {
        invoiceTypeValue: [{
          required: true,
          message: this.$t('fms_receive_invoice_apply_dialog.qtxxzfplx'),
        }],
        partnerInvoiceId: [{
          required: true,
          message: this.$t('fms_receive_invoice_apply_dialog.qxzfptt'),
        }],

      };
    },
    invoiceAmount: function () {
      const list = Array.isArray(this.model.row) ? [...this.model.row] : [this.model.row];
      return list.reduce((total, item) => {
        const { paymentAmount = 0, invoiceAmount = 0, lockInvoiceAmount = 0 } = item;
        const sum = paymentAmount - invoiceAmount - lockInvoiceAmount;
        return sum + total;
      }, 0);
    },
  },
  mounted: function () {
    const list = Array.isArray(this.model.row) ? [...this.model.row] : [this.model.row];
    this.firstItem = list[0];
    this.fullUrl = `${apis.crmPartnerInvoiceList}/${this.firstItem.payableOrgId}`;
  },
  methods: {
    onSubmitClose() {
      this.$emit('success');
      this.dialogVisible1 = false;
      this.closeDialog();
    },
    onSubmitSuccess() {
      this.$emit('success');
      this.closeDialog();
    },
    invoiceTypeChange(e) {
      const arr = e.split('-');
      this.form.invoiceType = arr[0];
      this.form.invoiceClass = arr[1];
    },
    // 发票申请（提交审批）
    onApplyDialog: function () {
      this.dialogModel1.type = 'add';
      this.dialogModel1.changeType = 'invoice';
      this.dialogModel1.title = this.$t('fms_receive_invoice_apply_dialog.kai_piao_shen_qing');
      this.dialogModel1.row = this.waitList;
      this.dialogVisible1 = true;
    },
    onGetInvoiceTypeList(list) {
      // form.invoiceType
      // 发票类型 默认选中 增值税专用发票
      if (!this.form.invoiceType) {
        const obj = list.find(item => item.code === 'special');
        if (obj) {
          this.form.invoiceType = obj.value;
        }
      }

    },
    onSuccess() {
      this.$refs.partnerInvoiceId.getSelectList();
    },
    addBodyItem() {
      this.bodyItemModel = {
        type: 'add',
        title: this.$t('fms_receive_invoice_apply_dialog.xzfptt')
      };
      this.bodyItemVisible = true;
    },
    onAddSuccess() {
      this.$refs.partnerInvoiceId.getSelectList();
    },
    onTitleChange(item) {
      this.form.buyerNumber = item.buyerNumber;
      this.form.buyerName = item.buyerName;
      this.form.buyerRegisterAddress = item.buyerRegisterAddress;
      this.form.buyerMobile = item.buyerMobile;
      this.form.buyerDepositBank = item.buyerDepositBank;
      this.form.buyerDepositNumber = item.buyerDepositNumber;
      this.form.buyerEmail = item.buyerEmail;
    },
    // 加入待入库
    onMark() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate((val) => {
          if (val) {
            const rows = Array.isArray(this.model.row) ? [...this.model.row] : [this.model.row];
            const billIdList = rows.map(item => item.billId);

            this.form.billIdList = billIdList;
            this.$postJSON(apis.invoiceMark, this.form, true).then((res) => {
              resolve(res);
            }).catch((e) => {
              reject(e);
            });
          } else {
            reject(new Error());
          }
        });
      });
    },
    async onSave() {
      try {
        if (this.submiting || !this.visible) {
          return;
        } else {
          this.submiting = true;
        }
        await this.onMark();

        this.submiting = false;

        this.$message({
          type: 'success',
          message: this.$t('Common.com_handle_success')
        });

        this.$emit('success');
        this.closeDialog();
      } catch (e) {
        this.submiting = false;
      }
    },
    async onSubmit() {
      try {
        if (this.submiting || !this.visible) {
          return;
        } else {
          this.submiting = true;
        }
        const { data } = await this.onMark();
        this.submiting = false;
        this.waitList = data;
        this.onApplyDialog();
      } catch (e) {
        this.submiting = false;
      }
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
  }
};
</script>

<style lang="scss">
.invoice-apply-dialog {
  .last-row {
    margin-bottom: 0 !important;
    position: relative;

    .el-form-item__label {
      position: relative;
      z-index: 0;
    }

    .add-invoice {
      line-height: 17px;
      height: 17px;
      position: absolute;
      top: 0;
      right: 0;
      z-index: 100;
      cursor: pointer;
      color: #00a0d9;
      .icon {
        float: left;
        font-size: 10px;
        $scale: 10 / 12;
        transform: scale($scale);
      }
      .label {
        float: left;
        padding-left: 5px;
        font-size: 12px;
      }
    }
  }
  .el-form-item__label {
    width: 100%;
    text-align: left;
  }

  .el-select {
    width: 100%;
  }

  .dialog-body {
    width: 100%;
    .msg-content {
      margin-top: 8px;
      padding: 14px;
      border: 1px solid rgba(240, 240, 240, 1);
      border-radius: 8px;
      margin-bottom: 14px;
      .title {
        line-height: 17px;
        color: #818181;
        font-weight: bold;
        font-size: 12px;
      }
      .msg-list {
        margin-top: 6px;
        > li {
          overflow: hidden;
          margin-top: 8px;
          line-height: 17px;
          font-size: 12px;
          .key {
            float: left;
            color: #4d4d4d;
            font-weight: bold;
          }
          .val {
            float: left;
            padding-left: 16px;
            color: #1a1a1a;
            font-weight: bold;
          }
        }
      }
    }
    .input-container {
      flex: 1;
      background: #fff;
    }
  }
}
</style>
